$(document).ready(function(){

    $('.g-teaser').addClass('is-loaded');

    const $items = $('.g-bg');
    let currentIndex = 0;

    $items.hide().eq(currentIndex).show();

    setInterval(function () {
        $items.eq(currentIndex).hide();

        currentIndex = (currentIndex + 1) % $items.length;

        $items.eq(currentIndex).show();
    }, 2000);

});